export const NAME = 'campaignSettings-tabs';

export const tabs = {
	CAMPAIGN: 142,
	STARTUP_CURVE: 172,
	ADDITIONAL_DATA: 146,
	STATES: 145,
	GUARANTORS: 143,
};
